import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { testMysqlConnection } from '@/service/dashboard';

// 异步 thunk actions
export const getImages = createAsyncThunk(
  'test/getImages',  // 修改action类型前缀
  async () => {
    // 调用真实API服务
    const response = await testMysqlConnection()
    return response.data  // 返回API响应数据
  }
)

// 初始状态
const initialState = {
  fetching: false,
  data: [],
  error: null
}

// 创建 slice
const testSlice = createSlice({  // 修改为正确的命名
  name: 'test',  // 修改name属性
  initialState,
  reducers: {
    resetImagesState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getImages.pending, (state) => {
        state.fetching = true
        state.error = null
      })
      .addCase(getImages.fulfilled, (state, action) => {
        state.fetching = false
        state.data = action.payload
      })
      .addCase(getImages.rejected, (state, action) => {
        state.fetching = false
        state.error = action.error.message
      })
  }
})

export const { resetImagesState } = testSlice.actions
export default testSlice.reducer  // 确保导出reducer